import React, { Component } from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "./owlcarousel.styles.css";
import carouselImage1 from "../../assets/img/portfolio-img1.jpg";
import carouselImage2 from "../../assets/img/portfolio-img2.jpg";
import carouselImage3 from "../../assets/img/portfolio-img3.jpg";
export class OwlCarouselComponent extends Component {
  render() {
    return (
      <div>
        <div className="container-fluid">
          <div className="row title" style={{ marginBottom: "20px" }}></div>
        </div>
        <div className="container-fluid">
          <OwlCarousel
            items={1}
            className="owl-theme"
            loop
            nav
            margin={8}
            autoplay={true}
          >
            <div className="item">
              <img className="carousel-img" src={carouselImage1} />
            </div>
            <div className="item">
              <img className="carousel-img" src={carouselImage2} />
            </div>
            <div className="item">
              <img className="carousel-img" src={carouselImage3} />
            </div>
          </OwlCarousel>
        </div>
      </div>
    );
  }
}
export default OwlCarouselComponent;
